import React, { useState } from 'react';
import classNames from 'classnames';
import Modal from 'react-modal';

export default ({ children, onClose, onAction, disabled }) => {

  return (
    <Modal
      isOpen={true}
      ariaHideApp={false}
      className="s-modal s-copywriter-modal"
      onRequestClose={onClose}
    >
      <div className="modal-dialog modal-lg s-modal__dialog">
        <div className="modal-content s-modal__content">
          <div className="s-modal__header">
            <button className="close s-modal__close" onClick={onClose}>
              <i className="fi fi-close"></i>
            </button>
            <div className="s-modal__title">{i18n.t('assistant.modal_title')}</div>
          </div>
          <div className="s-modal__body">
            {children}
            <div className="s-modal__actions">
              <button className="btn btn-form" onClick={onClose}>
                {i18n.t('cancel')}
              </button>
              <button className="btn btn-primary" onClick={onAction} disabled={disabled}>
                {i18n.t('assistant.paste_new_text')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
